import type { Board } from "../board";
import type { Direction } from "../direction";
import { Event } from "../events/event";
import { EventType } from "../events/eventType";
import type { Player } from "../player";
import { DevGunAutoKillBot } from "../things/devGunAutoKillBot";
import { Weapon } from "../weapon";

export class DevGunAutoKill extends Weapon {
	static key = "DevGunAutoKill";
	constructor(owner: Player) {
		super(owner, 0, true);
	}

	fire(_direction: Direction, board: Board): void {
		const existingBots = board.getPhysicalThings().filter((t) => t instanceof DevGunAutoKillBot);

		if (existingBots.length > 0) {
			board.addEvent(new Event(EventType.DEV_KILL_BOT_DEACTIVATED));
			for (const bot of existingBots) {
				board.removeAtEndOfTurn(bot);
			}
		} else {
			board.addEvent(new Event(EventType.DEV_KILL_BOT_ACTIVATED));
			board.addThing(new DevGunAutoKillBot(this.owner.xy));
		}
	}

	static deserialize(_data: any, owner: Player): DevGunAutoKill {
		return new DevGunAutoKill(owner);
	}
}
